/*
 * File: GetCourseInstructorPool.ts
 * Author: Austin Robinson
 * Date Created: 6/8/2023
 * Copyright (c) DrivingDoc 2023
 */
import { AxiosError } from 'axios';
import { createQuery } from 'react-query-kit';

import { Instructor } from 'api/hooks/private/users/instructors/GetInstructors.ts';
import { ErrorResponse, privateApi } from 'api/index.ts';

export interface GetCourseInstructorPoolParams {
  courseId: string;
  page: number;
  pageSize: number;
}

export type GetCourseInstructorPoolResult = {
  rows: Instructor[];
  count: number;
} | null;

async function getCourseInstructorPool(params: GetCourseInstructorPoolParams): Promise<GetCourseInstructorPoolResult> {
  const { courseId, ...queryParams } = params;
  // make api call
  const result = await privateApi.get<GetCourseInstructorPoolResult>(
    `${import.meta.env.VITE_API_BASE_URL}/courses/${courseId}/instructorPool`,
    {
      params: queryParams,
    },
  );

  // return the data object
  return result.data;
}

const useGetCourseInstructorPool = createQuery<
  GetCourseInstructorPoolResult,
  GetCourseInstructorPoolParams,
  AxiosError<ErrorResponse>
>({
  queryKey: ['course_instructor_pool'],
  fetcher: (variables) => getCourseInstructorPool(variables),
});

export { getCourseInstructorPool, useGetCourseInstructorPool };
